
const deploymentUrls = {
 api: "",
 client: ""
};

if(process.env.REACT_APP_ENV === "development"){
    deploymentUrls.api = process.env.REACT_APP_API_URL;
    deploymentUrls.client = process.env.REACT_APP_CLIENT_URL;
}

else if(process.env.REACT_APP_ENV === "developmentenv"){
    deploymentUrls.api = process.env.REACT_APP_API_URL;
    deploymentUrls.client = process.env.REACT_APP_CLIENT_URL;
}

else if(process.env.REACT_APP_ENV === "production"){
    deploymentUrls.api = process.env.REACT_APP_API_URL;
    deploymentUrls.client = process.env.REACT_APP_CLIENT_URL;
}

else if(process.env.REACT_APP_ENV === "test"){
    deploymentUrls.api = process.env.REACT_APP_API_URL;
    deploymentUrls.client = process.env.REACT_APP_CLIENT_URL;
}

else {
    deploymentUrls.api = 'https://localhost:7195/api/';
    deploymentUrls.client = 'http://localhost:3000/';
}


export default deploymentUrls;